module.exports = __webpack_public_path__ + "img/HoverFeedbackPoor.31e8f9ae.png";